import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import {
  RESERVE_FOR_SALE,
  DO_NOT_SELL,
  LIST,
  DO_NOT_LIST
} from "MODULES/inventories/constants";

export const getSellableClass = ({ status, sellable_status: sellableStatus }) =>
  classNames({
    "green-table-cap": sellableStatus === LIST && status !== RESERVE_FOR_SALE,
    "warning-table-cap":
      sellableStatus === DO_NOT_LIST && status !== RESERVE_FOR_SALE,
    "danger-table-cap":
      sellableStatus === DO_NOT_SELL || status === RESERVE_FOR_SALE
  });

export default function InventoryStatusCell({ inventory, children }) {
  if (!inventory) return null;
  return <td className={getSellableClass(inventory)}>{children}</td>;
}

InventoryStatusCell.propTypes = {
  inventory: PropTypes.shape({
    sellable_status: PropTypes.string.isRequired
  }).isRequired,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node)
  ])
};



// WEBPACK FOOTER //
// ./app/modules/shared/components/InventoryStatusCell/InventoryStatusCell.jsx